import React, { useCallback, useState, useEffect } from 'react'
import { Typography, makeStyles } from '@material-ui/core'
import moment from 'moment'
import { gray, purple } from '../../utils/colors'

const useStyles = makeStyles(() => ({
	root: { display: 'flex', flexDirection: 'column' },
	card: {
		backgroundColor: gray[100],
		boxShadow: 'none',
		border: `1px solid ${gray[400]}`,
		borderWidth: 1
	},
	noNotes: {
		fontWeight: '600',
		padding: 8,
		margin: 0
	},
	note: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		borderRadius: 6,
		paddingLeft: 4,
		paddingRight: 4,
		paddingTop: 8,
		paddingBottom: 8,
		flex: 1,
		marginBottom: 8,
		height: 58,
		'&:hover': {
			backgroundColor: gray[200],
			cursor: 'pointer'
		}
	},
	noteStatusSection: {
		width: '14%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		alignItems: 'center'
	},
	noteBody: {
		width: '86%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'flex-start',
		paddingLeft: 16
	},
	noteRow: {
		display: 'flex',
		flexDirection: 'row'
	},
	noteTitle: {
		fontSize: 14,
		color: purple[500],
		fontWeight: '800',
		marginRight: 6,
		textTransform: 'capitalize'
	},
	noteType: {
		fontSize: 14,
		color: purple[500],
		fontWeight: '600',
		marginRight: 6,
		textTransform: 'capitalize'
	},
	noteTags: {
		fontSize: 14,
		color: gray[700],
		fontWeight: '600',
		marginRight: 6,
		textTransform: 'capitalize'
	},
	noteDate: {
		fontSize: 14,
		color: gray[600],
		fontWeight: '600',
		marginRight: 6
	},
	noteDesc: {
		fontSize: 14,
		color: gray[700],
		fontWeight: '600',
		marginRight: 6
	},
	noteStatus: {
		fontWeight: '600',
		color: gray[800],
		fontSize: 14,
		padding: '2px 4px',
		border: `1px solid ${gray[400]}`,
		borderRadius: 4
	},
	descriptionParagraph: {
		margin: 0
	}
}))

// This isn't really a table
const NotesTable = ({ staff_notes = [], setStaffNote }) => {
	const classes = useStyles()
	const [staffNotes, setStaffNotes] = useState([])

	useEffect(() => {
		if (staff_notes) {
			setStaffNotes(staff_notes)
		}
	}, [staff_notes])

	const handleSetStaffNote = (note) => {
		if (setStaffNote) {
			setStaffNote(note)
		}
	}

	const getNoteTags = (note) => {
		if (note.tags && note.tags.length) {
			return note.tags.join(', ').replace(/_/g, ' ')
		}
		return ''
	}

	const getNoteTitle = (note) => {
		if (note.title) {
			return note.title
		}
		return 'Staff Note'
	}

	const getNoteType = (note) => {
		return note.type
	}

	const getColor = (note) => {
		if (note.tags && note.tags.includes('raise_alert')) {
			return '#DC2A2A'
		}
		return '#E5B35B'
	}

	const getNoteStatus = (note) => {
		return note.status || 'Open'
	}

	const renderDescription = useCallback((description) => {
		const paragraphs = description.split('\n')
		if (paragraphs.length < 2) {
			return description
		}

		const formatted = paragraphs.map((line) => <p className={classes.descriptionParagraph}>{line}</p>)
		return formatted
	}, [])

	return (
		<div className={classes.root}>
			{staffNotes.length ? (
				staffNotes.map((note) => {
					let color = getColor(note)
					return (
						<div style={{ flex: 1 }} className={classes.note} onClick={() => handleSetStaffNote(note)}>
							<div
								style={{
									height: 36,
									backgroundColor: color,
									width: 4,
									borderRadius: 8
								}}></div>
							<div className={classes.noteBody}>
								<div className={classes.noteRow}>
									<Typography className={classes.noteTitle}>{getNoteTitle(note)}</Typography>
									<Typography className={classes.noteType}>{getNoteType(note)}</Typography>
									<Typography className={classes.noteTags}>{getNoteTags(note)}</Typography>
								</div>
								<div className={classes.noteRow}>
									<Typography className={classes.noteDate}>
										{moment(note.createdAt).format('MMM D YYYY, hh:mma')}
									</Typography>
									<Typography className={classes.noteDesc}>
										<div>{renderDescription(note.description || '')}</div>
									</Typography>
								</div>
							</div>
							<div className={classes.noteStatusSection}>
								<Typography className={classes.noteStatus}>{getNoteStatus(note)}</Typography>
							</div>
						</div>
					)
				})
			) : (
				<div className={classes.noNotes}>No Notes</div>
			)}
		</div>
	)
}

export default NotesTable
